import { useQueryWithUserId } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';
import { ITradeInDevicesBrandParams } from '../types';

/**
 * This is to track the device brands from the backend.
 */
const DEVICE_BRANDS_KEY = 'device-brands-key';

/**
 * This hook fetches a list of device brand id and name.
 * These brand ids and names are mapped in the step-3 `TradeInDeviceDropdown`
 * component.
 */
export const useDeviceBrandsQuery = (params: ITradeInDevicesBrandParams) => {
  const { categoryId } = params;
  const { data, isError, error, isEnabled, isPending, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [DEVICE_BRANDS_KEY, categoryId],
      networkMode: 'always',
      queryFn: () => USER_REGISTRATION_API.fetchTradeInDeviceBrands(params),
      enabled: !!categoryId,
    });

  return {
    data,
    error,
    isError,
    isEnabled,
    isPending,
    refetch,
  };
};
